var _circle, _circle2, _path, _path2, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContractorOnMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2227 5.77778C11.2227 5.34822 11.5709 5 12.0004 5C12.43 5 12.7782 5.34822 12.7782 5.77778V10.4444C12.7782 10.874 12.43 11.2222 12.0004 11.2222C11.5709 11.2222 11.2227 10.874 11.2227 10.4444V5.77778Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4446 7.5603C9.5858 7.81636 8.79544 8.28287 8.15031 8.928C7.12927 9.94903 6.55566 11.3338 6.55566 12.7778L17.4446 12.7778C17.4446 11.3338 16.8709 9.94903 15.8499 8.928C15.2048 8.28287 14.4144 7.81636 13.5557 7.5603V10.7037C13.5557 11.4196 12.8592 12 12.0001 12C11.141 12 10.4446 11.4196 10.4446 10.7037V7.5603Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 13.5557,
    width: 2.33333,
    height: 14,
    rx: 1.16667,
    transform: "rotate(90 19 13.5557)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractorOnMap);
export default __webpack_public_path__ + "static/media/contractor-on-map.ba07c050.svg";
export { ForwardRef as ReactComponent };